import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { chooseSelectedInquiryTypeSpecificComponent } from 'shared/chooseSelectedInquiryTypeSpecificComponent';

import ExistingUserCompanySelect from './ExistingUserCompanySelect';
import { MittweidaExistingUserCompanySelect } from '../../../../../../mittweida/inquiry/steps/company/sections/companyDetails/components/companySuggestion/MittweidaExistingUserCompanySelect';

export default chooseSelectedInquiryTypeSpecificComponent({
  [InquiryType.profiMittweida]: MittweidaExistingUserCompanySelect,
  [InquiryType.hausbank]: MittweidaExistingUserCompanySelect,
  [InquiryType.cbBank]: MittweidaExistingUserCompanySelect,
  default: ExistingUserCompanySelect,
});
